/**
 * @file Adaptateurs de stockage de la sauvegarde : localStorage (navigateur, avec copie de secours) et memoire (tests).
 */

export interface StorageAdapter {
  load(key: string): Promise<string | null>;
  save(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
}

export class LocalStorageAdapter implements StorageAdapter {
  async load(key: string): Promise<string | null> {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  async save(key: string, value: string): Promise<void> {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      console.error('Save failed (quota / private mode ?)', e);
    }
  }

  async remove(key: string): Promise<void> {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }
}

export class MemoryStorageAdapter implements StorageAdapter {
  private readonly map = new Map<string, string>();
  async load(key: string): Promise<string | null> {
    return this.map.get(key) ?? null;
  }
  async save(key: string, value: string): Promise<void> {
    this.map.set(key, value);
  }
  async remove(key: string): Promise<void> {
    this.map.delete(key);
  }
}

export const SAVE_KEY = 'catgunner2.save';
export const SAVE_BACKUP_KEY = 'catgunner2.save.bak';
export const DEVICE_KEY = 'catgunner2.device';
